<template>
  <ul class="nav nav-tabs mb-4">
    <li class="nav-item">
      <router-link class="nav-link" :to="routes.details" exact>Detail</router-link>
    </li>

    <li @click="tabAccessWarning" class="nav-item">
      <router-link
        class="nav-link"
        :class="[activeRoute(routeNames.graduates), { 'disabled': !programExists }]"
        :to="routes.graduates"
        exact
      >Graduates</router-link>
    </li>

    <li @click="tabAccessWarning" class="nav-item">
      <router-link
        class="nav-link"
        :class="[activeRoute(routeNames.uploadDocuments), { 'disabled': !programExists }]"
        :to="routes.uploadDocuments"
        exact
      >Upload Documents</router-link>
    </li>

    <li @click="tabAccessWarning" class="nav-item">
      <router-link
        class="nav-link"
        :class="[activeRoute(routeNames.resources), { 'disabled': !programExists }]"
        :to="routes.resources"
        exact
      >Resources</router-link>
    </li>
  </ul><!-- /.nav -->
</template>

<script>
import { programComputed } from 'vx/helpers'
import { alert } from 'utils'
import { startsWith } from 'lodash'

export default {
  computed: {
    ...programComputed,

    routes () {
      if (this.programExists) {
        return {
          details: { name: 'programs.details', params: { id: this.program.id } },
          graduates: { name: 'programs.graduates', params: { id: this.program.id } },
          uploadDocuments: { name: 'programs.upload', params: { id: this.program.id } },
          managerAssignments: { name: 'programs.managers', params: { id: this.program.id } },
          resources: { name: 'programs.resources', params: { id: this.program.id } }
        }
      }

      return {
        details: { name: 'programs.create' },
        graduates: '/',
        uploadDocuments: '/',
        managerAssignments: '/',
        resources: '/'
      }
    },

    routeNames () {
      if (this.programExists) {
        return {
          details: 'programs.details',
          graduates: 'programs.graduates',
          uploadDocuments: 'programs.upload',
          managerAssignments: 'programs.managers',
          resources: 'programs.resources'
        }
      }

      return {
        details: 'programs.create',
        graduates: '',
        uploadDocuments: '',
        managerAssignments: '',
        resources: ''
      }
    }
  },

  methods: {
    tabAccessWarning () {
      if (!this.$route.params.id) {
        alert.warning({
          title: 'Program Unsaved',
          text: 'Unable to access tab while draft is unsaved'
        })
      }
    },

    activeRoute (name) {
      if (name) {
        if (startsWith(this.$route.name, name)) {
          return 'active'
        }
      }
      return ''
    }
  }
}
</script>
